/** uview-plus 内置图标（与 mobile u-icon name 一致） */
const UVIEW_ICON_GLYPHS: Record<string, string> = {
  'gift-fill': '\ue65c',
  'share-fill': '\ue65e',
  'shopping-cart-fill': '\ue65d',
  'red-packet-fill': '\ue690',
  'hourglass-half-fill': '\ue966',
  'clock-fill': '\ue638',
  'thumb-up-fill': '\ue72f',
  'edit-pen-fill': '\ue66b',
  scan: '\ue662',
  'star-fill': '\ue669',
  'chat-fill': '\ue61e',
  'bag-fill': '\ue617',
  'grid-fill': '\ue678',
  'play-circle-fill': '\ue655',
  'calendar-fill': '\ue634',
  'pushpin-fill': '\ue86e',
  'map-fill': '\ue64e',
  'home-fill': '\ue964',
  reload: '\ue788'
}

export const MARKET_FILTER_UVIEW_ICONS = {
  festival: 'calendar-fill',
  industry: 'bag-fill',
  scene: 'pushpin-fill'
} as const

export function getUviewIconGlyph(name: string): string {
  return UVIEW_ICON_GLYPHS[name] || UVIEW_ICON_GLYPHS['gift-fill']
}
